import { BankOfferItem, ClassActionItem, UnclaimedItem } from "@/types/feed";
import { ApiResponse, POST } from "./index";

// Sign in response interface (adjust based on your API response structure)

type FeedItemListResponse = {
  data: (ClassActionItem | BankOfferItem | UnclaimedItem)[];
};

// Authentication service functions
const FeedServices = {
  /**
   * Get list of feed items
   * @returns Promise<ApiResponse<FeedItemListResponse>>
   */
  getList: async (): Promise<ApiResponse<FeedItemListResponse>> => {
    return await POST<FeedItemListResponse>("/feed-item/list");
  },
  hideItem: async (feedItemId: string): Promise<ApiResponse<null>> => {
    return await POST<null>("/feed-filter/push", {
      feedItemId,
    });
  },
};

export default FeedServices;
